import { render, staticRenderFns } from "./IAChat.vue?vue&type=template&id=68325d81&scoped=true"
var script = {}
import style0 from "./IAChat.vue?vue&type=style&index=0&id=68325d81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68325d81",
  null
  
)

export default component.exports